import React, { useMemo, useRef, useEffect, forwardRef } from 'react'
import {
  CheckboxGroup,
  Checkbox,
  Stack,
  Box,
  HStack,
  Input,
  useMergeRefs,
} from "@chakra-ui/react"
import { Controller, useController } from 'react-hook-form'
import usePrettyOptions from '../../hooks/usePrettyOptions'

const CheckboxInput = forwardRef(({ children = [], control, name, rules, ...props }, ref) => {
  const prettyOptions = usePrettyOptions(children)
  const { field } = useController({ name, control, rules })
  const hasOther = useMemo(() => field.value?.includes('other'), [field.value])
  const otherRef = useRef()
  useEffect(() => {
    if (hasOther) {
      setTimeout(() => {
        otherRef.current?.focus()
      })
    }
  }, [hasOther])
  return (
    <CheckboxGroup colorScheme="primary" {...props} ref={ref} {...field}>
      <Stack spacing={4}>
        {prettyOptions.map(({ value, label }, i) => <Box key={value + i}><Checkbox value={value} isRequired={false}>{label}</Checkbox></Box>)}
        <HStack spacing={4}>
          <Checkbox value="other" flexShrink="0" isRequired={false}>
            其他
          </Checkbox>
          <Controller
            name={`${name}Other`}
            control={control}
            render={({ field: otherField }) => (
              <Input
                size="sm"
                variant="flushed"
                isDisabled={!hasOther}
                {...otherField}
                // eslint-disable-next-line react-hooks/rules-of-hooks
                ref={useMergeRefs(otherRef, otherField.ref)}
              />
            )}
          />
        </HStack>
      </Stack>
    </CheckboxGroup>
  )
})

CheckboxInput.displayName = 'CheckboxInput'

export default CheckboxInput
